import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const TypeServiceConfig = {
  name: "Type",
  annotations: []
} as ServiceConfig;